// Siren + beeper audio engine (Web Audio) for the Vehicle Studio.
let ctx = null;
let nodes = null;
let customSource = null;
let customBuffer = null;
let beeperNodes = null;

function ac() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

const PATTERNS = {
  wail: { base: 700, peak: 1500, rate: 0.14, type: "sawtooth" },
  yelp: { base: 650, peak: 1500, rate: 0.55, type: "sawtooth" },
  phaser: { base: 600, peak: 1250, rate: 2.4, type: "square" },
  hilow: { base: 660, peak: 880, rate: 1.6, type: "triangle" },
};

export function startSiren(pattern = "wail", rateMul = 1) {
  stopSiren();
  if (pattern === "custom" && customBuffer) {
    const c = ac();
    customSource = c.createBufferSource();
    customSource.buffer = customBuffer;
    customSource.loop = true;
    const g = c.createGain();
    g.gain.value = 0.5;
    customSource.connect(g).connect(c.destination);
    customSource.start();
    return;
  }
  const p = PATTERNS[pattern] || PATTERNS.wail;
  const c = ac();
  const osc = c.createOscillator();
  osc.type = p.type;
  osc.frequency.value = p.base;
  const lfo = c.createOscillator();
  lfo.type = "triangle";
  lfo.frequency.value = p.rate * rateMul;
  const lfoGain = c.createGain();
  lfoGain.gain.value = (p.peak - p.base) / 2;
  lfo.connect(lfoGain).connect(osc.frequency);
  osc.frequency.value = (p.base + p.peak) / 2;
  const g = c.createGain();
  g.gain.value = 0.16;
  const filter = c.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 3200;
  osc.connect(filter).connect(g).connect(c.destination);
  osc.start();
  lfo.start();
  nodes = { osc, lfo, g };
}

export function stopSiren() {
  try { nodes?.osc.stop(); nodes?.lfo.stop(); } catch { /* stopped */ }
  try { customSource?.stop(); } catch { /* stopped */ }
  nodes = null;
  customSource = null;
}

export async function loadCustomSiren(file) {
  const c = ac();
  const buf = await file.arrayBuffer();
  customBuffer = await c.decodeAudioData(buf);
  return customBuffer.duration;
}

export function startBeeper() {
  stopBeeper();
  const c = ac();
  const osc = c.createOscillator();
  osc.type = "square";
  osc.frequency.value = 1100;
  const gate = c.createGain();
  gate.gain.value = 0;
  const lfo = c.createOscillator();
  lfo.type = "square";
  lfo.frequency.value = 2.2;
  const lfoG = c.createGain();
  lfoG.gain.value = 0.07;
  lfo.connect(lfoG).connect(gate.gain);
  gate.gain.value = 0.07;
  osc.connect(gate).connect(c.destination);
  osc.start();
  lfo.start();
  beeperNodes = { osc, lfo };
}

export function stopBeeper() {
  try { beeperNodes?.osc.stop(); beeperNodes?.lfo.stop(); } catch { /* stopped */ }
  beeperNodes = null;
}
